import H1  from './H1';

export default H1;
